import { PhoneNumberUtil } from 'google-libphonenumber';
import { ServiceManager } from '@jutro/services';
import { logDeprecationMessage } from '@jutro/platform';
import { log } from '@jutro/logger';
import LocaleSettingsInterface from './LocaleSettingsInterface';
import { getCountryCodeFromLocale } from './locale';
const DATE_SHORT = {
  year: 'numeric',
  month: '2-digit',
  day: '2-digit'
};
const DATE_LONG = {
  year: 'numeric',
  month: 'long',
  day: 'numeric'
};
function getLocaleSettings() {
  return ServiceManager.getServiceByContract(LocaleSettingsInterface);
}
function getDefaultLocale() {
  const localeSettings = getLocaleSettings();
  return localeSettings ? localeSettings.getPreferredLocale() : {};
}
export const formatISOShortDate = date => {
  logDeprecationMessage('formatISOShortDate');
  let stringDate = '';
  if (date.getTime()) {
    stringDate = date.toISOString().substr(0, 10);
  }
  return stringDate;
};
export const formatShortDate = (date, locale = getDefaultLocale()) => {
  logDeprecationMessage('formatShortDate');
  return date.toLocaleString(locale, DATE_SHORT);
};
export const formatLongDate = (date, locale = getDefaultLocale()) => {
  logDeprecationMessage('formatLongDate');
  return date.toLocaleString(locale, DATE_LONG);
};
export const formatCurrency = (amount, currency, locale = getDefaultLocale()) => {
  logDeprecationMessage('formatCurrency');
  return amount.toLocaleString(locale, {
    style: 'currency',
    currency,
    currencyDisplay: 'code'
  });
};
export const formatPhoneNumber = (phoneNumber, locale = getDefaultLocale()) => {
  logDeprecationMessage('formatPhoneNumber');
  const phoneUtils = PhoneNumberUtil.getInstance();
  const phoneRegion = getCountryCodeFromLocale(locale) || getLocaleSettings().getDefaultPhoneCountry();
  try {
    return phoneUtils.format(phoneUtils.parse(phoneNumber, phoneRegion));
  } catch (e) {
    log.warning("Unable to format phone number '".concat(phoneNumber, "': ").concat(e.message));
    return phoneNumber;
  }
};
export const formatPhoneNumberAndCountryCode = (phoneNumber, countryCodeIso2) => {
  const phoneUtils = PhoneNumberUtil.getInstance();
  try {
    var _rawInput$getCountryC;
    const rawInput = phoneUtils.parseAndKeepRawInput(phoneNumber, countryCodeIso2);
    const countryCode = ((_rawInput$getCountryC = rawInput.getCountryCode()) === null || _rawInput$getCountryC === void 0 ? void 0 : _rawInput$getCountryC.toString()) || '';
    const formattedPhoneNumber = phoneUtils.format(phoneUtils.parse(phoneNumber, countryCodeIso2));
    return [countryCode, formattedPhoneNumber];
  } catch (error) {
    log.warning("Unable to format phone number '".concat(phoneNumber, "': ").concat(error.message));
    return [];
  }
};